<script>
import gql from 'graphql-tag'

export default {
  props: [
    'siteID',
  ],
  name: 'SelectSites',
  computed: {
    siteIDModel: {
      get() {
        return this.siteID
      },

      set(val) {
        this.$emit('siteIDChanged', val)
      }
    }
  },
  apollo: {
    sites: {
      query: gql`query {paymentSites {    name    id   }}`,
      client: 'private',
      update(data) {
        const sites = data.paymentSites

        if (sites.length > 0) {
          this.siteIDModel = sites[0].id
        }

        return sites.map((item) => {
          return {
            text: item.name,
            value: item.id,
          }
        })
      }
    },
  },
}
</script>

<template>
  <v-select
      v-if="siteIDModel != null"
      :items="sites"
      label="Сайты"
      v-model="siteIDModel"
  >
  </v-select>
</template>
